const api_url = "https://clairity-api-nng2e7f6fq-uc.a.run.app/clairity";

export default api_url;